import React from 'react'
import './kitNosotras.scss'
import Title from '../../atoms/title/title'
import ImagenKit from '../../../assets/images/home/kit-Nosotras.png'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby-link'
import useMediaQuery from '../../../utils/useMediaQuery'
import { kitWin, LOCALE } from '../../../constants/activity-constants'

const KitNosotras = ({ isLogged }) => {
  const isMobile = useMediaQuery()
  // const infoKit = {
  //   // img: ImagenKit,
  //   content: [
  //     '5 Toallas Nosotras Antibacterial  ',
  //     '1 muestra de Jabón Íntimo Nosotras Sensiti - V',
  //     '8 Protectores Nosotras Diarios Algodón 100% Orgánico',
  //     '1 Folleto con toda la información sobre la pubertad, para consultar cuando quieras.',
  //   ],
  // }

  const infoKit = () => {
    switch (LOCALE) {
      case 'es-EC':
        return [
              '3 Toallas Nosotras Buenas Noches Natural  ',
              '3 Toallas Nosotras Invisible Rapigel',
              '3 Toallas Nosotras Sensitiv',
              '2 Toallas Nosotras',
              '5 Protectores Nosotras Multiestilo',
              '1 muestra de Jabón Íntimo Herbal',
              '1 Folleto con toda la información sobre la pubertad, para consultar cuando quieras.',
        ]
      default:
        return [
              '5 Toallas Nosotras Antibacterial  ',
              '1 muestra de Jabón Íntimo Nosotras Sensiti - V',
              '8 Protectores Nosotras Diarios Algodón 100% Orgánico',
              '1 Folleto con toda la información sobre la pubertad, para consultar cuando quieras.',
        ]
    }
  }

  return (
    <section className="f-section-kit-nosotras">
      <div className="f-section-kit-nosotras__wrapper">
        <div className="f-section-kit-nosotras__content">
          {!isMobile && (
            <div className="f-section-kit-nosotras__kit">
              <img
                src={kitWin[LOCALE]?.kit || kitWin['es-CO'].kit}
                alt="Kit Nosotras"
              />
            </div>
          )}
          <div className="f-section-kit-nosotras__description">
            <div className="f-section-kit-nosotras__description__title">
              <Title
                color="purple"
                // txt={['Participa', 'por un Kit Nosotras', 'y gana:']}
                txt={LOCALE === 'es-EC' ? ['Participa', 'por un Kit Nosotras', 'y gana:'] : ['Participa', 'por un Kit Nosotras']}
              />
            </div>
            {isMobile && (
              <div className="f-section-kit-nosotras__kit">
                <img
                  src={kitWin[LOCALE]?.kit || kitWin['es-CO'].kit}
                  alt="Kit Nosotras"
                />
              </div>
            )}
            {LOCALE === 'es-EC' 
              ? <ul>
                  {infoKit().map((item, index) => {
                    return <li key={`kititem-${index}`}>{item}</li>
                  })}
                </ul>
              : null
            }
            
            <div className="f-section-kit-nosotras__button">
              <Button
                color="pink"
                text={isLogged ? 'Ir a las actividades' : 'Participa'}
                action={() => {
                  try {
                    window.dataLayer.push({
                      event: 'ga_event',
                      category: 'Vive el Cole :: Home',
                      action: 'Click :: Kit Nosotras',
                      label: isLogged ? 'Ir a las actividades' : 'Participa',
                      value: '',
                    })
                  } catch (error) {
                    console.log('Datalayer error:', error)
                  }
                  navigate('actividades')
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default KitNosotras
